import domready from 'domready';
import Utilities from '@js/src/Utilities';

export default {
    bind(el, binding) {
        // Get the name of the tab to change
        let name = el.href.substr(el.href.indexOf('#') + 1);

        // The tab control
        domready(() => {
            let nav = Utilities.getParents(el, '.tab-controls__nav')[0];
            let tabs = nav.querySelectorAll('.tab-controls__nav__link');
            let tabPanes = nav.parentNode.querySelectorAll('.tab-controls__tabs .tab-controls__tabs__pane');

            el.addEventListener('click', event => {
                event.preventDefault();

                // Activate correct tab
                tabs.forEach(tab => {
                    if (tab.href === el.href) {
                        tab.classList.add('active');
                    } else {
                        tab.classList.remove('active');
                    }
                });

                // Activate correct content area
                tabPanes.forEach(pane => {
                    if (pane.id === name) {
                        pane.classList.add('active');
                    } else {
                        pane.classList.remove('active');
                    }
                });

                return false;
            });
        });
    },
};
